import {
  getProductDetailsById,
  getProductRegistryById,
} from '@americanexpress/product-ducks';

const getProductFromRegistryData = (state, selectedProduct, cardProductsList) => {
  const registry = getProductRegistryById(state, selectedProduct) || {};
  let details = {};

  if (selectedProduct && cardProductsList.length > 0) { // only cards, not ps
    details = getProductDetailsById(state, selectedProduct) || {};
  }

  return { details, registry };
};

export default getProductFromRegistryData;
